// src/routes/PatientRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from '@dr.pogodin/react-helmet';
import DashboardLayout from '../components/layout/DashboardLayout';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import RoleBasedRoute from '../components/auth/RoleBasedRoute';

// Patient Pages
import PatientDashboard from '../pages/patient/PatientDashboard';
import BookConsultation from '../pages/patient/BookConsultation';
import MyConsultations from '../pages/patient/MyConsultations';
import OrderMedicine from '../pages/patient/OrderMedicine';
import MyOrders from '../pages/patient/MyOrders';
import MedicalHistory from '../pages/patient/MedicalHistory';
import Prescriptions from '../pages/patient/Prescriptions';
import PatientProfile from '../pages/patient/PatientProfile';
import EmergencyRequest from '../pages/patient/EmergencyRequest';
import ManageDependents from '../pages/patient/ManageDependents';

const PatientRoutes = () => {
  return (
    <ProtectedRoute>
      <RoleBasedRoute allowedRoles={['patient']}>
        <Routes>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={
              <>
                <Helmet>
                  <title>Patient Dashboard - MediGo</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <PatientDashboard />
              </>
            } />
            
            <Route path="consultation/book" element={
              <>
                <Helmet>
                  <title>Book Consultation - MediGo Patient Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <BookConsultation />
              </>
            } />
            
            <Route path="consultations" element={
              <>
                <Helmet>
                  <title>My Consultations - MediGo Patient Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <MyConsultations />
              </>
            } />
            
            <Route path="dependents" element={
              <>
                <Helmet>
                  <title>Manage Dependents - MediGo Patient Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <ManageDependents />
              </>
            } />
            
            <Route path="medicine/order" element={
              <>
                <Helmet>
                  <title>Order Medicine - MediGo Patient Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <OrderMedicine />
              </>
            } />
            
            <Route path="orders" element={
              <>
                <Helmet>
                  <title>My Orders - MediGo Patient Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <MyOrders />
              </>
            } />
            
            <Route path="medical-history" element={
              <>
                <Helmet>
                  <title>Medical History - MediGo Patient Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <MedicalHistory />
              </>
            } />
            
            <Route path="prescriptions" element={
              <>
                <Helmet>
                  <title>Prescriptions - MediGo Patient Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <Prescriptions />
              </>
            } />
            
            <Route path="profile" element={
              <>
                <Helmet>
                  <title>Patient Profile - MediGo Account</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <PatientProfile />
              </>
            } />
            
            <Route path="emergency" element={
              <>
                <Helmet>
                  <title>Emergency Request - MediGo Patient Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <EmergencyRequest />
              </>
            } />
          </Route>
        </Routes>
      </RoleBasedRoute>
    </ProtectedRoute>
  );
};

export default PatientRoutes;